import { useState, useEffect } from 'react';
import ImageUpload from '../ImageUpload';
import { apiGet, apiPut } from '../api';

export default function HeroSection() {
  const [data, setData] = useState({
    logo_image: '',
    facebook_url: '',
    instagram_url: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await apiGet('hero.php');
      setData(result);
    } catch (err) {
      setMessage('Erro ao carregar dados');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      const result = await apiPut('hero.php', data);
      setMessage(result.success ? 'Salvo com sucesso!' : 'Erro ao salvar');
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Erro ao salvar dados');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div>Carregando...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Hero & Redes Sociais</h2>

      <div className="space-y-4">
        <ImageUpload
          currentImage={data.logo_image}
          onImageChange={(path) => setData({ ...data, logo_image: path })}
          label="Logo"
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL Facebook
          </label>
          <input
            type="url"
            value={data.facebook_url}
            onChange={(e) => setData({ ...data, facebook_url: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="https://www.facebook.com/bolacha.mulata"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL Instagram
          </label>
          <input
            type="url"
            value={data.instagram_url}
            onChange={(e) => setData({ ...data, instagram_url: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="https://www.instagram.com/bolacha.mulata/"
          />
        </div>
      </div>

      {message && (
        <div className={`p-4 rounded-lg ${message.includes('sucesso') ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={isSaving}
        className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 disabled:opacity-50"
      >
        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
      </button>
    </div>
  );
}
